
  <section >
    <div class="wrapper">
    <div class="styled-input">
      <label class="diagnostic-label"  style="width: 90%;left: 0%;">Nursing Assessment</label>

    <!-- <button type="button" class="add-boutton" style="left: 1732px;" name="Add">Add</button> -->
    </div>
</div>
<BR>
<BR>
  <div >
    <input type="checkbox" name="concet" [(ngModel)]="patientConsent" style="width: 22px;height: 22px;"  required="" />
    <label style="width: 6.5%;color: {{wk_color}};font-size: 100%;font-weight: bold;">Patient Consent</label>
    <label >                                                                    </label>
    <a style="cursor: grab;">
      <button   type="button"  class="add-boutton" style=" width: 80px" (click)="NursingEntry()">Update</button>
    </a>
  </div>
<Table style="table-layout: fixed;width: 90%;">
  <tr style="font-size: 100%;text-align: center;background-color: #7cbc44;color: black;">
  <th class="table_header" style="width: 20%;background-color: #7cbc44;color: black;">Date</th>
  <th class="table_header" style="width: 12%;background-color: #7cbc44;color: black;">Weight</th>
  <th class="table_header" style="width: 12%;background-color: #7cbc44;color: black;">height</th>
  <th class="table_header" style="width: 12%;background-color: #7cbc44;color: black;">Puls</th>
  <th class="table_header" style="width: 12%;background-color: #7cbc44;color: black;">Temp</th>
  <th class="table_header" style="width: 15%;background-color: #7cbc44;color: black;">Blood Pressure</th>
  <th class="table_header" style="width: 20%;background-color: #7cbc44;color: black;">Notes</th>

</tr>
<tr *ngFor="let item of nurseassesseList; let i = index" style="text-align: center;">
  <td data-column="Item Date" style="font-weight: {{item.visitlocation}};">{{item.visitdate}}</td>
  <td data-column="Item weight" style="font-weight: {{item.visitlocation}};">{{item.weight}}</td>
  <td data-column="Item Height" style="font-weight: {{item.visitlocation}};">{{item.height}}</td>
  <td data-column="Item puls" style="font-weight: {{item.visitlocation}};">{{item.pulse}}</td>
  <td data-column="Item temp" style="font-weight: {{item.visitlocation}};">{{item.temp}}</td>
  <td data-column="Item prusser" style="font-weight: {{item.visitlocation}};">{{item.pressure}}</td>
  <td data-column="Item Notes" style="font-weight: {{item.visitlocation}};">{{item.nursenote}}</td>
</tr>
</Table>
</section>

